import { BookmarkSimple } from "@phosphor-icons/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { actions } from "astro:actions";
import { toast } from "sonner";

import { useLocale } from "~/hooks/locale";

export const BookmarkPack: React.FC<{
  packId: number;
  isBookmarked: boolean;
}> = ({ packId, isBookmarked }) => {
  const { t } = useLocale();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: actions.pack.bookmark.orThrow,
    onError: (error) => {
      toast.error("Failed to bookmark pack", {
        description: error.message,
      });
    },
    onSuccess: (isBookmarked, { packId }) => {
      queryClient.setQueryData<
        Awaited<ReturnType<typeof actions.me.getBookmarks.orThrow>>
      >(
        ["bookmarks"],
        (prev) =>
          prev && {
            ...prev,
            bookmarks: isBookmarked
              ? prev.bookmarks.concat({ packId })
              : prev.bookmarks.filter((bookmark) => bookmark.packId !== packId),
          },
      );
    },
  });
  return (
    <button
      disabled={isPending}
      onClick={() =>
        mutate({
          packId,
          remove: isBookmarked,
        })
      }
    >
      <BookmarkSimple
        weight={isBookmarked ? "fill" : "bold"}
        className="size-4"
      />
      {isBookmarked ? t("unbookmark") : t("bookmark")}
    </button>
  );
};
